/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferSalaryUnitEnum = 'Hour' | 'Week' | 'Month' | 'Year';

export const OfferSalaryUnitEnum = {
    Hour: 'Hour' as OfferSalaryUnitEnum,
    Week: 'Week' as OfferSalaryUnitEnum,
    Month: 'Month' as OfferSalaryUnitEnum,
    Year: 'Year' as OfferSalaryUnitEnum
};

